import * as types from "../../ActionType";

const initState = {
    account_types: [],
    loadingAccountTypes: true,
}

const AccountTypeReducer = (state = initState, action) => {
    switch (action.type) {
        case types.ADD_ACCOUNT_TYPE:
            return { ...state, loadingAccountTypes: true }
        case types.GET_ACCOUNT_TYPES:
            return { ...state, account_types: action.payload, loadingAccountTypes: false }
        case types.DELETE_ACCOUNT_TYPE:
            return { ...state }
        case types.EDIT_ACCOUNT_TYPE:
            return { ...state, loadingAccountTypes: true }
        default:
            return state;
    }
};

export default AccountTypeReducer;

